export const COOKIE_KEY = 'user_token';

export const AUTH_INFO_KEY = 'auth_info';

export const VERSION = 'v1';




// WEBPACK FOOTER //
// ./config/session.js